import { Component, Input, OnInit } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { ObtenerInformacionPagoPrestamoME, ParametrizacionService, PrestamoPagoModeloMLS, PrestamoService } from 'src/app/open-api';

@Component({
  selector: 'app-prestamo-movimiento',
  templateUrl: './prestamo-movimiento.component.html',
  styleUrls: ['./prestamo-movimiento.component.scss']
})
export class PrestamoMovimientoComponent implements OnInit {

  @Input() set SecuencialPrestamo(secuencial: number) {
    this.secuencialPrestamo = secuencial;

  }
  secuencialPrestamo = 0;
  movimientos: PrestamoPagoModeloMLS[] = [];
  movimientosLista: PrestamoPagoModeloMLS[] = [];
  hoy = new Date();
  fechaInicio =  new Date();
  fechaFin = new Date();
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;
  minFechaInicio = new Date();
  fechaMinima = new Date();
  mesesRango = 0;

  constructor(
    private prestamoService: PrestamoService,
    private spinner: NgxSpinnerService,
    private localeService: BsLocaleService,
    private parametrizacion :ParametrizacionService,
  ) {
    this.localeService.use('es');
  }

  async ngOnInit() {
      const ahora = new Date();
      this.fechaInicio = new Date(ahora.getFullYear(), ahora.getMonth() - 5, ahora.getDate());
      this.fechaFin = new Date(); 
      this.ObtenerMovimientos();
      await this.obtenerParametrizacion()
  }

  ListarMovimientos() {
    this.movimientosLista = this.movimientos
      .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
  }

  ObtenerMovimientos() {
    this.spinner.show();
    const parametro: ObtenerInformacionPagoPrestamoME = {
      secuencialPrestamo: this.secuencialPrestamo,
      fechaFinal: this.fechaFin,
      fechaInicial: this.fechaInicio
    };
    this.prestamoService.apiV10PrestamoObtenerInformacionPagoPost(parametro).subscribe(movimientos => {
      this.movimientos = (movimientos?.movimientosPrestamo || []);
      this.cantidad = (movimientos?.movimientosPrestamo?.length || 0);
      this.ListarMovimientos();
      this.spinner.hide();
    });

  }


  async obtenerParametrizacion(){
    this.spinner.show();
    this.parametrizacion.apiV10ParametrizacionObtenerParametrizacionOperacionesPost().subscribe(item => {
        this.mesesRango = Number(item.operaciones?.find(g => g.id == 1)?.valor ?? 0);
      
        const ahora = new Date();
        this.minFechaInicio = new Date(ahora.getFullYear(), ahora.getMonth() - this.mesesRango, ahora.getDate());
       
        this.spinner.hide();
      
    }, error => {
        this.spinner.hide();
    });
}
}
